import SpamList from './SpamList';

export default SpamList;
